import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { storeToRefs } from 'pinia'
import BikefittingLayout from '@/components/layout/BikefittingLayout.vue'
import MainMenu from '@/components/layout/MainMenu.vue'
import TheHeader from '@/components/layout/TheHeader.vue'
import ConnectionBar from '@/components/controls/ConnectionBar.vue'
import BikeModules from '@/components/controls/BikeModules.vue'
import { useUserStore } from '@/store/userStore'
import { usePreferenceStore } from '@/store/preferenceStore'
import { NConfigProvider, darkTheme } from 'naive-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

const userStore = useUserStore()
const { dealerName } = storeToRefs(userStore)

const preferenceStore = usePreferenceStore()
const { hasFitbike } = storeToRefs(preferenceStore)

window.addEventListener('beforeunload', function (e) {
  e.preventDefault()
  e.returnValue = ''
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(BikefittingLayout, { "has-bike": _unref(hasFitbike) }, {
    mainMenu: _withCtx(() => [
      _createVNode(MainMenu, { "dealer-name": _unref(dealerName) }, null, 8, ["dealer-name"])
    ]),
    header: _withCtx(() => [
      _createVNode(TheHeader)
    ]),
    hardwareHeader: _withCtx(() => [
      _createVNode(_unref(NConfigProvider), {
        theme: _unref(darkTheme),
        style: {"flex":"1","margin":"0 6rem"}
      }, {
        default: _withCtx(() => [
          _createVNode(ConnectionBar)
        ]),
        _: 1
      }, 8, ["theme"])
    ]),
    hardwareModules: _withCtx(() => [
      _createVNode(_unref(NConfigProvider), { theme: _unref(darkTheme) }, {
        default: _withCtx(() => [
          _createVNode(BikeModules)
        ]),
        _: 1
      }, 8, ["theme"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_RouterView)
    ]),
    _: 1
  }, 8, ["has-bike"]))
}
}

})